export const GRAPHQL_URL = '';
